




























































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import VueMultiselect from 'vue-multiselect/src/Multiselect.vue';

@Component({
  components: {
    VueMultiselect,
  },
})
export default class Dropdown extends Vue {
  @Prop(String) public dropdownApplyString: string;
  @Prop(Array) public options: any;
  @Prop(String) public optionPrefix: string;
  @Prop(Boolean) public taggable: boolean;
  @Prop(Boolean) public searchable: boolean;
  @Prop(String) public placeholder: string;
  @Prop(Boolean) public allowEmptyOption: boolean;
  @Prop({ default: true, type: Boolean }) public closeOnSelect: boolean;
  @Prop(Boolean) public buttonAfterItemList: boolean;
  @Prop(Boolean) public customCaret: boolean;

  selected = this.options.filter((option) => option.selected) || null;

  get dropdownOptions() {
    if (this.allowEmptyOption) {
      return [{ value: null, text: '' }].concat(this.options);
    }
    return this.options;
  }

  get _closeOnSelect() {
    return this.options.length <= 1 || this.closeOnSelect;
  }

  @Watch('options')
  public setSelected() {
    this.selected = this.options.filter((option) => option.selected) || this.selected;
  }

  @Emit('change')
  public performChange() {
    return this._getSelected();
  }

  @Emit('close')
  public performClose() {
    return this._getSelected();
  }

  public displayText(option) {
    return option.raw ? option.value : this.translatedOptionText(option);
  }

  public translatedOptionText(option) {
    return this.$i18n.t(this.optionText(option));
  }

  public optionText(option) {
    return this.optionPrefix && !option.text
      ? Vue.filter('translationPrefix')(option.value, this.optionPrefix)
      : option.text;
  }

  private _getSelected() {
    return this.taggable ? this.selected.map((obj) => obj.value) : this.selected.value;
  }

  private _onAcceptButtonClick($event) {
    let target;
    if (this.customCaret) {
      target = $event.currentTarget.parentElement.parentElement.parentElement.querySelector('.multiselect__select-caret');
    } else {
      target = $event.currentTarget.parentElement.parentElement.parentElement.querySelector('.multiselect__select');
    }
    target.dispatchEvent(new MouseEvent('mousedown', { ...$event }));
  }
}
